module.exports = __webpack_public_path__ + "img/img_4.a13cb5bf.png";